(function ($) {
  'use strict';

  /*
   * SpecsAtHome — Optimised main.js
   *
   * Goals:
   * - Reduce forced reflow during scroll
   * - Reduce repeated DOM queries
   * - Improve INP / main-thread responsiveness
   * - Preserve existing menu, filter, popup and modal behaviour
   * - Do NOT control the mini-cart here
   */

  var state = {
    scrollTicking: false,
    lastSticky: null,
    lastTopVisible: null,
    topButton: null,
    headerAreas: []
  };

  function cacheScrollElements() {
    state.topButton = document.getElementById('top');
    state.headerAreas = Array.prototype.slice.call(
      document.querySelectorAll('.header-area')
    );
  }

  function initMenuClasses() {
    $('.megamenu-li')
      .parent('.container')
      .parent('ul')
      .addClass('mega-menu');

    $('.banner-wrap')
      .parent('.container')
      .parent('ul')
      .addClass('bottom-banner');

    $('.menu-banner')
      .parent('.container')
      .parent('ul')
      .addClass('banner-menu');

    $('.submenu-li')
      .parent('.container')
      .parent('ul')
      .addClass('sub-menu');

    $('.submenu-li')
      .parent('ul')
      .addClass('sub-menu');

    $('.megamenu-li')
      .parent('ul')
      .addClass('mega-menu');

    $('.bannermenu-li')
      .parent('ul')
      .addClass('banner-menu');
  }

  function initNewsletterPopup() {
    try {
      var popup = localStorage.getItem('popup_value');

      if (
        popup !== '1' &&
        $.fn.modal &&
        $('#news-letter-modal').length
      ) {
        $('#news-letter-modal').modal('show');
      }
    } catch (error) {}

    $('#popup-close')
      .off('click.sahPopup')
      .on('click.sahPopup', function () {
        try {
          localStorage.setItem('popup_value', '1');
        } catch (error) {}
      });
  }

  function initMobileMenu() {
    $('button.navbar-toggle')
      .off('click.sahMenu')
      .on('click.sahMenu', function () {
        $('.main-menu-area').addClass('active');
        $('.mm-fullscreen-bg').addClass('active');
        document.body.classList.add('hidden');
      });

    $('.close-box')
      .off('click.sahMenu')
      .on('click.sahMenu', function () {
        $('.main-menu-area').removeClass('active');
        $('.mm-fullscreen-bg').removeClass('active');
        document.body.classList.remove('hidden');
      });
  }

  function initFilters() {
    $('button.filter-button')
      .off('click.sahFilter')
      .on('click.sahFilter', function () {
        $('.filter-sidebar').addClass('active');
        $('.mm-fullscreen-bg').addClass('active');
      });

    $('button.close-filter-sidebar')
      .off('click.sahFilter')
      .on('click.sahFilter', function () {
        $('.filter-sidebar').removeClass('active');
        $('.mm-fullscreen-bg').removeClass('active');
      });
  }

  function initGlobalOverlay() {
    $('.mm-fullscreen-bg')
      .off('click.sahGlobal')
      .on('click.sahGlobal', function () {
        /*
         * Mini-cart manages its own overlay / body state.
         * Never close legacy menu/filter layers while
         * the mini-cart is currently open.
         */
        if (document.querySelector('.mini-cart.show')) {
          return;
        }

        $('.main-menu-area').removeClass('active');
        $('.filter-sidebar').removeClass('active');
        $('.mm-fullscreen-bg').removeClass('active');

        document.body.classList.remove('hidden');
      });
  }

  function initTooltips() {
    if (
      !window.bootstrap ||
      typeof window.bootstrap.Tooltip !== 'function'
    ) {
      return;
    }

    var tooltipTriggerList =
      document.querySelectorAll('[data-bs-toggle="tooltip"]');

    tooltipTriggerList.forEach(function (element) {
      /*
       * Avoid creating multiple Bootstrap tooltip instances.
       */
      try {
        if (
          typeof bootstrap.Tooltip.getInstance === 'function' &&
          bootstrap.Tooltip.getInstance(element)
        ) {
          return;
        }

        new bootstrap.Tooltip(element);
      } catch (error) {}
    });
  }

  function initPopupMedia() {
    if (!$.fn.magnificPopup) {
      return;
    }

    $('.play-button, .popup-vimeo, .popup-gmaps')
      .off('.sahMagnific')
      .magnificPopup({
        tClose: 'Close (Esc)',
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
  }

  function initBackToTop() {
    if (!state.topButton) {
      return;
    }

    $(state.topButton)
      .off('click.sahTop')
      .on('click.sahTop', function (event) {
        event.preventDefault();

        /*
         * Native scroll avoids jQuery animation calculations.
         */
        try {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        } catch (error) {
          window.scrollTo(0, 0);
        }
      });
  }

  function initAgreementCheckbox() {
    /*
     * Event delegation is bound ONCE.
     * The previous theme implementation used to bind this
     * repeatedly while scrolling.
     */
    $(document)
      .off('click.sahAgree', 'label.box-area')
      .on(
        'click.sahAgree',
        'label.box-area',
        function () {
          var checkbox =
            document.querySelector('.cust-checkbox');

          var agree =
            document.querySelector('.agree');

          if (!agree) {
            return;
          }

          if (checkbox && checkbox.checked) {
            agree.classList.remove('disabled');
          } else {
            agree.classList.add('disabled');
          }
        }
      );
  }

  function initThemeUI() {
    cacheScrollElements();

    initMenuClasses();
    initNewsletterPopup();
    initMobileMenu();
    initFilters();
    initGlobalOverlay();
    initTooltips();
    initPopupMedia();
    initBackToTop();
    initAgreementCheckbox();
  }

  /*
   * -------------------------------------------------------
   * SCROLL PERFORMANCE
   * -------------------------------------------------------
   *
   * IMPORTANT:
   * Do not use:
   *
   *   $('#top').fadeIn()
   *   $('#top').fadeOut()
   *   $('.header-area') on every scroll
   *
   * Those operations were contributing to forced reflow.
   */

  function updateBackToTop(scrollTop) {
    var visible = scrollTop > 1000;

    /*
     * Do nothing if state did not change.
     */
    if (visible === state.lastTopVisible) {
      return;
    }

    state.lastTopVisible = visible;

    if (!state.topButton) {
      return;
    }

    state.topButton.classList.toggle(
      'is-visible',
      visible
    );

    state.topButton.setAttribute(
      'aria-hidden',
      visible ? 'false' : 'true'
    );
  }

  function updateStickyHeader(scrollTop) {
    var sticky = scrollTop >= 150;

    /*
     * Avoid rewriting classes every animation frame.
     */
    if (sticky === state.lastSticky) {
      return;
    }

    state.lastSticky = sticky;

    state.headerAreas.forEach(function (header) {
      header.classList.toggle(
        'is-sticky',
        sticky
      );
    });
  }

  function updateOnScroll() {
    var scrollTop =
      window.scrollY ||
      window.pageYOffset ||
      0;

    updateBackToTop(scrollTop);
    updateStickyHeader(scrollTop);

    state.scrollTicking = false;
  }

  function onScroll() {
    if (state.scrollTicking) {
      return;
    }

    state.scrollTicking = true;

    window.requestAnimationFrame(
      updateOnScroll
    );
  }

  function boot() {
    initThemeUI();

    /*
     * Establish initial sticky / top button state.
     */
    updateOnScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  /*
   * Passive listener prevents scroll-blocking behaviour.
   */
  window.addEventListener(
    'scroll',
    onScroll,
    { passive: true }
  );

  /*
   * Shopify Theme Editor:
   * refresh cached DOM references when a section
   * is dynamically re-rendered.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      cacheScrollElements();
      initBackToTop();
      initTooltips();

      state.lastSticky = null;
      state.lastTopVisible = null;

      updateOnScroll();
    }
  );

})(jQuery);